import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import logger from 'redux-logger';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import authReducer from './auth-slice';
import bedSensorReducer from './bed-sensor-slice';
import historyReducer from './history-slice';
import queryReducer from './query-slice';
import snackbarReducer from './snackbar-slice';
import userReducer from './user-slice';

const rootReducer = combineReducers({
  auth: authReducer,
  history: historyReducer,
  queries: queryReducer,
  snackbar: snackbarReducer,
  users: userReducer,
  bedSensors: bedSensorReducer,
});

const persistConfig = {
  key: 'redux',
  storage,
  whitelist: ['auth'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const options = {
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    };
    if (process.env.NODE_ENV === 'development') {
      return getDefaultMiddleware(options).concat(logger);
    }
    return getDefaultMiddleware(options);
  },
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
